/* eslint-disable no-unused-vars */
import { format } from "date-fns";
import syncStatusDict from "dictionaries/sync_status.json";
import { ID } from "models";
import { Badge } from "reactstrap";
import { SyncStatusKeys } from "types/keys";
import Tooltip from "ui/Tooltip";
import getTitleFromDict from "utils/getTitleFromDict";
import TStatusDisplay from "./type";
import {ReactNode} from "react";

const statusBadgeColors: { [k in SyncStatusKeys]: string } = {
  SYNC_NOT_NEEDED: "bg-primary",
  READY_TO_SYNC: "bg-primary",
  IS_SYNCHRONIZING: "bg-info",
  SYNCHRONIZED: "bg-success",
  SYNC_ERROR: "bg-danger",
  TEMPORARY_SYNC_ERROR: "bg-warning",
  REGISTERED: "bg-success",
  PARTIALLY_REGISTERED: "bg-success"
};

export const statusBadgeText: {
  [k in SyncStatusKeys]: (
    _ordAccount?: string,
    _itemId?: ID,
    _error_message?: string,
    _synced_at?: string,
    _account?: string,
  ) => string;
} = {
  SYNC_NOT_NEEDED: () => `Для договоров саморекламы ${syncStatusDict["SYNC_NOT_NEEDED"].toLowerCase()}`,
  READY_TO_SYNC: () => syncStatusDict["READY_TO_SYNC"],
  IS_SYNCHRONIZING: (ordAccount, itemId, error_message, synced_at, account) =>
    `${syncStatusDict["IS_SYNCHRONIZING"]} на аккаунт ${account}.`,
  SYNCHRONIZED: (ordAccount, itemId, error_message, synced_at, account) => {
    return `${syncStatusDict["SYNCHRONIZED"]} на аккаунт ${account}.`
  },
  SYNC_ERROR: (ordAccount, itemId, error_message, synced_at, account) =>
    `${
      synced_at ? `${format(new Date(synced_at), "dd.MM.yyyy, HH:mm:SS")} ` : ""
    }${syncStatusDict["SYNC_ERROR"]} ${itemId} в аккаунте ${account}: ${error_message}.`,
  TEMPORARY_SYNC_ERROR: (ordAccount, itemId, error_message, synced_at, account) =>
    `${
      synced_at ? `${format(new Date(synced_at), "dd.MM.yyyy, HH:mm:SS")} ` : ""
    }${syncStatusDict["TEMPORARY_SYNC_ERROR"]} ${itemId} в аккаунте ${account}: ${error_message}.`,
  REGISTERED: (ordAccount, itemId, error_message, synced_at, account) => `${syncStatusDict["REGISTERED"]} на аккаунт ${account} ${ordAccount}.`,
  PARTIALLY_REGISTERED: (ordAccount, itemId, error_message, synced_at, account) =>
    `${syncStatusDict["PARTIALLY_REGISTERED"]} на аккаунт ${account}.`
};

const StatusInline = ({ data, dictionary }: TStatusDisplay) => {
  if (data?.extra_fields?.sync_status?.length) {
    const { sync_status: rowSyncStatus } = data?.extra_fields || {};
    const { id: rowId } = data;
    return (
      rowSyncStatus &&
      <div className="d-inline-flex flex-wrap gap-1">
        {rowSyncStatus.map((syncStatus) => {
          const isNotSelfAd = syncStatus.status === "SYNC_NOT_NEEDED" &&
            "contract_type" in data &&
            data.contract_type !== 4

          if (isNotSelfAd) {
            return <>{data?.status ? getTitleFromDict(data.status, dictionary) : ""}</>;
          }

          const isSyncStatus = !syncStatus ||
            !syncStatus?.status ||
            !Object.keys(statusBadgeText).includes(syncStatus.status)

          if (isSyncStatus) {
            console.log(syncStatus, syncStatus.status);
            return <></>;
          }

          const itemId = `${syncStatus.ord}-${new Date(syncStatus.synced_at!).getTime()}-${rowId}`;

          return (
            <Tooltip
              key={itemId}
              id={itemId}
              maxWidth="10em"
              target={
                <Badge className={statusBadgeColors[syncStatus.status]} pill id={itemId}>
                  {syncStatus.ord.charAt(0).toUpperCase()}
                </Badge> as ReactNode
              }
            >
              {statusBadgeText[syncStatus.status](
                syncStatus.ord,
                rowId,
                syncStatus.error_message,
                syncStatus.synced_at,
                syncStatus.account
              )}
            </Tooltip>
          );
        })}
      </div>
    );
  }

  return <>{data?.status ? getTitleFromDict(data.status, dictionary) : ""}</>;
};

export default StatusInline;
